"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiAvatar = getMuiAvatar;
function getMuiAvatar() {
  return {
    styleOverrides: {
      root: function (_ref) {
        var theme = _ref.theme;
        return {
          '&:focus-visible': {
            border: 'none',
            boxShadow: "0px 0px 0px 4px ".concat(theme.palette.gray[200]),
            outline: 'none'
          },
          '.MuiAvatar-img': {
            '&:focus-visible': {
              border: 'none',
              boxShadow: "0px 0px 0px 4px ".concat(theme.palette.gray[100]),
              outline: 'none'
            }
          },
          '.MuiSvgIcon-root': {
            height: 24,
            width: 24
          },
          backgroundColor: theme.palette.gray[100],
          border: 'solid',
          borderColor: 'rgba(18, 25, 38, 0.08)',
          borderRadius: 200,
          borderWidth: 0.75,
          color: theme.palette.gray[600],
          fontSize: 16,
          fontWeight: 600,
          height: 40,
          lineHeight: 24,
          width: 40
        };
      }
    },
    variants: [{
      props: {
        sizes: 'xs'
      },
      style: {
        '.MuiSvgIcon-root': {
          height: 16,
          width: 16
        },
        borderWidth: 0.5,
        fontSize: 12,
        fontWeight: 600,
        height: 24,
        lineHeight: 18,
        width: 24
      }
    }, {
      props: {
        sizes: 'sm'
      },
      style: {
        '.MuiSvgIcon-root': {
          height: 20,
          width: 20
        },
        borderWidth: 0.5,
        fontSize: 14,
        fontWeight: 600,
        height: 32,
        lineHeight: 20,
        width: 32
      }
    }, {
      props: {
        sizes: 'lg'
      },
      style: {
        '.MuiSvgIcon-root': {
          height: 28,
          width: 28
        },
        fontSize: 18,
        fontWeight: 600,
        height: 48,
        lineHeight: 28,
        width: 48
      }
    }, {
      props: {
        sizes: 'xl'
      },
      style: {
        '.MuiSvgIcon-root': {
          height: 32,
          width: 32
        },
        fontSize: 20,
        fontWeight: 600,
        height: 56,
        lineHeight: 30,
        width: 56
      }
    }, {
      props: {
        sizes: '2xl'
      },
      style: {
        '.MuiSvgIcon-root': {
          height: 32,
          width: 32
        },
        fontSize: 24,
        fontWeight: 600,
        height: 64,
        lineHeight: 32,
        width: 64
      }
    }]
  };
}